import { createFileRoute } from '@tanstack/react-router'
import { TagManagerView } from '@/features/tags/tags'

export const Route = createFileRoute('/_authenticated/tags/')({
  component: TagManagerView,
})
